// extracted by mini-css-extract-plugin
export default {"anchor":"Anchor_anchor__4o5R9","preview":"Anchor_preview__y9uSh","arrow":"Anchor_arrow__YVm1F"};